import { SPACE_ICON_GC_TIME_MS, SPACE_ICONS_QUERY_PATH, } from '#pplx/frontend/apps/ask/queries/spaces-queries/constants.js';
import { getSpaceIconKey } from '#pplx/frontend/apps/ask/queries/spaces-queries/getSpaceIconKey.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
/**
 * Push-seed per-icon cache entries from a list/batch response so later
 * useSpaceIconQuery reads are cache hits. React Query is a document cache, not a
 * normalized one — cross-query entity sharing is built manually by seeding
 * from the call sites that own the QueryClient (precedent: useAllResultsQuery
 * seeding thread metadata).
 */
export function seedSpaceIcons(queryClient, icons) {
    // Seeded-but-unobserved entries would otherwise be evicted (memory + IDB)
    // by the 5-minute default gcTime. Idempotent; prefix-matches all icon keys.
    queryClient.setQueryDefaults(QueryClientHelper.makeQueryKey(SPACE_ICONS_QUERY_PATH, 'symbol'), {
        gcTime: SPACE_ICON_GC_TIME_MS,
    });
    for (const icon of icons) {
        queryClient.setQueryData(getSpaceIconKey(icon.id), icon);
    }
}
//# sourceMappingURL=seedSpaceIcons.js.map